export const LOGIN_ROUTE = '/auth'
export const LOGOUT_ROUTE = '/logout'
export const FORBIDDEN_ROUTE = '/forbidden'

export const INVALID_USER_MESSAGE = 'Necessária a reautenticação.'
